import { render, staticRenderFns } from "./evection.vue?vue&type=template&id=4874f3b9&"
import script from "./evection.vue?vue&type=script&lang=js&"
export * from "./evection.vue?vue&type=script&lang=js&"
import style0 from "./evection.vue?vue&type=style&index=0&id=4874f3b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports